export class SectorField {
    componentId: string;
    name: string;
    value: string | number;

    constructor(componentId: string, name:string, value: string | number) {
        this.componentId = componentId;
        this.name = name;
        this.value = value;
    }

    setNameAndValue(name:string, value: string | number) {
        this.value = value;
        this.name = name;
    }

    getValue(): string | number {
        return this.value;
    }

    getStringValue(): string | undefined {
        return typeof(this.value) === "number" ? this.value.toString() : this.value;
    }
}

